import { render, staticRenderFns } from "./PrepareDocumentsPage.vue?vue&type=template&id=251318c0&scoped=true&"
import script from "./PrepareDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./PrepareDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrepareDocumentsPage.vue?vue&type=style&index=0&id=251318c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251318c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
